RivalIQ.apps.LandscapeSettings.module('views', function (views, App, Backbone, Marionette, $, _) {

    'use strict';

    views.Duplicate = RivalIQ.views.ItemView.extend({
        ui: {
            modal: '.modal',
            duplicate: '.x-landscape-duplicate'
        },
        events: {
            'click @ui.duplicate': 'duplicateLandscape'
        },
        template: '#landscapeSettingsDuplicateModalTemplate',
        onRender: function () {
            const me = this;
            me.ui.modal.modal();
        },
        duplicateLandscape: function () {
            const me = this;

            const url = [
                '/api/landscapes',
                me.model.id,
                'duplicate'
            ].join('/');

            me.ui.duplicate.prop('disabled', true);

            $.post(url)
                .done(function () {
                    window.location.reload();
                })
                .fail(function () {
                    RivalIQ.execute('alert:danger', 'An error occurred duplicating your landscape. Please try again.');
                    me.ui.duplicate.prop('disabled', undefined);
                });
        }
    });

});
